import * as tslib_1 from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL } from "../../config/urls";
import { toastr } from "react-redux-toastr";
import ReactTable from "react-table";
// @ts-ignore
import Rodal from "rodal";
var qs = require("qs");
var SubthemeList = /** @class */ (function (_super) {
    tslib_1.__extends(SubthemeList, _super);
    function SubthemeList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            searching: false,
            newSubTheme: '',
            subthemes: [],
            page: 0,
            pageSize: 20,
            currentSubTheme: { title: '', id: null },
            showRodal: false,
        };
        return _this;
    }
    SubthemeList.prototype.componentWillMount = function () {
        this.getSubThemes();
    };
    SubthemeList.prototype.render = function () {
        var _this = this;
        var columns = [{
                Header: '#',
                accessor: 'id',
                width: 100,
                style: { textAlign: 'center' }
            }, {
                Header: 'Название',
                accessor: 'title',
            }, {
                Header: 'Управление',
                sortable: false,
                width: 150,
                style: { textAlign: 'center' },
                Cell: function (props) {
                    return (React.createElement("div", { className: "btn-group" },
                        React.createElement("button", { onClick: _this.editSubTheme.bind(_this, props.row._original), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-edit" })),
                        React.createElement("button", { onClick: _this.removeSubTheme.bind(_this, props.row.id), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-trash" }))));
                }
            }];
        return (React.createElement(React.Fragment, null,
            React.createElement(Rodal, { onClose: function () {
                    _this.setState({ showRodal: false, currentSubTheme: { title: '', id: null } });
                }, visible: this.state.showRodal, width: 400, height: 400 },
                React.createElement("div", { className: "form-group" },
                    "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u0442\u0435\u043C\u044B",
                    React.createElement("input", { className: "form-control cols-xs-12", style: { width: '100%' }, name: "name", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState(function (prevState) {
                                var cc = prevState.currentSubTheme;
                                cc.title = value;
                                return { currentSubTheme: cc };
                            });
                        }, value: this.state.currentSubTheme.title, type: "text" })),
                React.createElement("button", { type: 'button', onClick: this.updateSubTheme.bind(this), className: "btn btn-primary btn-lg btn-block", style: { color: '#fff' } }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col col-xs-2 pull-left" },
                    React.createElement("h3", null,
                        "\u041F\u043E\u0434\u0442\u0435\u043C\u044B \u0442\u0435\u043C\u044B \u2116",
                        this.props.match.params.id)),
                React.createElement("div", { className: "col col-xs-3 pull-right" },
                    React.createElement("input", { type: "text", value: this.state.newSubTheme, onChange: function (e) { _this.setState({ newSubTheme: e.target.value }); } }),
                    React.createElement("button", { onClick: this.newSubTheme.bind(this), className: "btn btn-primary", style: { color: '#fff' } }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u0434\u0442\u0435\u043C\u0443"))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement(ReactTable, { previousText: '\u041D\u0430\u0437\u0430\u0434', nextText: '\u0412\u043F\u0435\u0440\u0435\u0434', loadingText: 'Loading...', noDataText: '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E', pageText: '\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430', ofText: '\u0438\u0437', rowsText: '\u0441\u0442\u0440\u043E\u043A', page: this.state.page, pages: Math.ceil(this.state.pages / this.state.pageSize), loading: this.state.loading, minRows: 1, manual: true, onPageChange: this.nextPage.bind(this), onSortedChange: this.onSort.bind(this), onPageSizeChange: this.onPageSize.bind(this), data: this.state.subthemes, columns: columns })))));
    };
    SubthemeList.prototype.getSubThemes = function () {
        var _this = this;
        this.setState({ loading: true });
        var searchString = 'page=' + (this.state.page + 1) + '&sort=' + this.state.sort + '&limit=' + this.state.pageSize;
        axios.get(API_URL + '/subthemes/' + this.props.match.params.id + '?' + searchString, {
            headers: { 'Authorization': this.props.auth_token }
        }).then(function (resp) {
            _this.setState({
                subthemes: resp.data.data ? resp.data.data : [], pages: resp.data.meta.total,
                loading: false
            });
        }).catch(function (error) {
            if (error.response && error.response.status === 403) {
                toastr.error('Ошибка', 'У Вас недостаточно прав');
            }
        });
    };
    SubthemeList.prototype.nextPage = function (page) {
        var _this = this;
        this.setState({ page: page }, function () { return _this.getSubThemes(); });
    };
    SubthemeList.prototype.onSort = function (sort) {
        var _this = this;
        this.setState({ sort: sort[0].desc ? '-' + sort[0].id : sort[0].id }, function () { return _this.getSubThemes(); });
    };
    SubthemeList.prototype.onPageSize = function (pageSize) {
        var _this = this;
        this.setState({
            pageSize: pageSize,
            page: 0,
        }, function () {
            _this.getSubThemes();
        });
    };
    SubthemeList.prototype.removeSubTheme = function (id) {
        var _this = this;
        var result = confirm('Вы уверены, что хотите удалить тему?');
        if (result) {
            axios.delete(API_URL + '/subtheme/' + id, {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.getSubThemes();
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    SubthemeList.prototype.newSubTheme = function () {
        var _this = this;
        var result = confirm('Добавить подтему?');
        if (result && this.state.newSubTheme.trim().length > 0) {
            axios.post(API_URL + '/subtheme', qs.stringify({
                title: this.state.newSubTheme,
                theme_id: this.props.match.params.id,
            }), {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                toastr.success('Успех', 'Подтема добавлена');
                _this.setState({ newSubTheme: '' }, function () {
                    _this.getSubThemes();
                });
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    SubthemeList.prototype.editSubTheme = function (subtheme) {
        this.setState({ showRodal: true, currentSubTheme: subtheme });
    };
    SubthemeList.prototype.updateSubTheme = function () {
        var _this = this;
        if (this.state.currentSubTheme.title.trim().length > 0) {
            axios.put(API_URL + '/subtheme/' + this.state.currentSubTheme.id, qs.stringify({
                title: this.state.currentSubTheme.title,
                theme_id: this.props.match.params.id,
            }), {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function (e) {
                toastr.success('Успех', 'Подтема обновлена');
                _this.setState({ currentSubTheme: { title: '', id: null }, showRodal: false }, function () {
                    _this.getSubThemes();
                });
            }).catch(function (e) {
                if (e.response && e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response && (e.response.data.code === 406 || e.response.data.code === 409)) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    return SubthemeList;
}(React.Component));
export default connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
}); })(SubthemeList);



//////////////////
// WEBPACK FOOTER
// ./src/views/themes/subthemes.tsx
// module id = 530
// module chunks = 0